export default __webpack_public_path__ + "static/main-video-poster-96180a7d8ecc4d7923054a170176ff2c.webp";